/**
 * MAGSDK basic implementation of fs plugin.
 *
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */


var baseMountPath     = '/ram/mnt',
    defaultMediaTypes = {
        video: [
            'mpg', 'mpeg', 'mov', 'mp4', 'avi', 'mkv', '3gp', 'ts', 'vob', 'wmv', 'mts', 'm2t', 'm2v',
            'divx', 'm2ts', 'm2p', 'tp', 'flv', 'mod', 'tod', 'asf', 'tts', 'm4v', 'trp', 'wtv'
        ],
        audio: ['mp3', 'wav', 'ac3', 'ogg', 'oga', 'aiff', 'wv', 'tta', 'wma', 'aac', 'dts', 'flac', 'ape', 'm4a'],
        image: ['jpg', 'jpeg', 'png', 'bmp', 'tif', 'tiff', 'raw', 'gif', 'cr2', 'nef', 'orf', 'iiq', 'ico', 'psd', 'webp', 'tif', 'tiff'],
        text:  ['txt', 'srt', 'sub', 'ass'],
        playlist:  ['cue', 'm3u', 'm3u8'],
        diskImage: ['iso'],
        record:    ['tspinf']
    },
    activeRegisterTypes,
    tools;


tools = {
    /**
     * Construct relatively comprehensive info about error.
     *
     * @param {Object} error error object
     * @param {string} error.cause custom field which describes error cause
     * @param {string} error.line line where error happens
     * @param {string} error.message what is actually happened
     * @param {string} error.stack error stack
     *
     * @return {string} constructed error message
     */
    parseError: function ( error ) {
        return 'Error in magcore-plugin-fs plugin!' +
               '\nAction: '  + error.cause +
               '\nLine: '    + error.line +
               '\nMessage: ' + error.message +
               '\nStack:\n'  + error.stack;
    },
    /**
     * Call given callback with arbitrary set of parameters in async manner.
     *
     * @param {function} callback callback function to call
     */
    asyncCall: function ( callback ) {
        var params = [].slice.call(arguments, 1);

        setTimeout(function () {
            try {
                callback.apply(null, params);
            } catch ( error ) {
                throw error;
            }
        }, 0);
    }
};


/**
 * @constructor
 *
 * @param {Object} config configuration options
 *
 * @example
 * var fs = core.plugins.fs;
 *
 * // get all registered extensions for "video" file type
 * fs.mediaTypes.video
 *
 * // get file type by its extension
 * fs.ext2Type['mp4']
 *
 * // get extensions of playable files
 * fs.mediaTypes.playable
 *
 * // get all registered file extensions
 * fs.mediaTypes.registered
 */
function Fs ( config ) {
    'use strict';

    var self = this;

    this.ext2Type = {};

    this.mountPath = config.app && config.app.mountPath || baseMountPath;

    this.mediaTypes = (config.options || {}).mediaTypes || defaultMediaTypes;

    this.types = this.mediaTypes.registered = Object.keys(this.mediaTypes).reduce(function ( pull, type ) {
        if ( type !== 'registered' && type !== 'playable' ) {
            return pull.concat(self.mediaTypes[type]);
        }

        return pull;
    }, []);

    this.mediaTypes.playable = this.mediaTypes.video.concat(
        this.mediaTypes.audio,
        this.mediaTypes.image,
        this.mediaTypes.playlist,
        this.mediaTypes.diskImage
    );

    Object.keys(this.mediaTypes).forEach(function ( type ) {
        self.mediaTypes[type].forEach(function ( ext) {
            self.ext2Type[ext] = type;
        });
    });

    Object.defineProperty(this, 'onMount', { // eslint-disable-line
        set: function ( fn ) {
            stbEvent.addListener('message', function ( event ) { // eslint-disable-line
                if ( event.broadcast ) {
                    if ( event.message === 'storage.mount' ) {
                        fn(true);
                    } else if ( event.message === 'storage.unmount' ) {
                        fn(false);
                    }
                }
            });
        }
    });
}


/**
 * Get read-only storage access status.
 *
 * @return {boolean} is device mounted in read-only mode
 */
Fs.prototype.getReadOnlyState = function () {
    return core.environment.mount_media_ro === 'true'; // eslint-disable-line
};


/**
 * Asynchronously read the contents of a directory.
 *
 * @param {string} path path to the directory in file system
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.readDir = function ( path, callback ) {
    var data;

    if ( this.types !== activeRegisterTypes ) {
        gSTB.SetListFilesExt('.' + this.types.join(' .'));
        activeRegisterTypes = this.types;
    }

    try {
        // two local variables occur: "dirs" and "files".
        eval(gSTB.ListDir(path, true));

        data = {
            dirs: dirs.reduce(function ( acc, item ) { // eslint-disable-line
                return acc.concat(item === '' ? [] : {name: item.slice(0, -1), type: 9});
            }, []),
            files: files.reduce(function ( acc, item ) { // eslint-disable-line
                return item.name ? acc.concat(item) : acc;
            }, [])
        };

        tools.asyncCall(callback, null, data);
    } catch ( error ) {
        error.cause = '[readDir] invalid data from gSTB.listDir';
        tools.asyncCall(callback, tools.parseError(error));
    }
};


/**
 * Asynchronously read the file..
 *
 * @param {string} path path to the file in file system
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.readFile = function ( path, callback ) {
    'use strict';

    tools.asyncCall(callback, null, gSTB.RDir('GetFile "' + path + '"'));
};


/**
 * Set new register file types dynamically.
 *
 * @param {Object[]} types new set of file types
 */
Fs.prototype.setTypes = function ( types ) {
    'use strict';

    this.types = this.mediaTypes.registered = types;
};


/**
 * List of all mounted partitions.
 *
 * @return {Object} mount points in a form of a set of objects
 */
Fs.prototype.getMountPoints = function () {
    'use strict';

    var snList = {}, // Set of all serial numbers with amount of partitions on each
        info   = JSON.parse(gSTB.GetStorageInfo('{}')); // Get mount points

    // valid non-empty data
    if ( Array.isArray(info.result) && info.errMsg === '' && info.result.length > 0 ) {
        info.result.forEach(function ( item ) {
            // SD card-reader support
            item.mediaType = item.sn === '000022272228' ? 3 : item.mediaType;
            item.label = item.label.trim();

            if ( snList[item.sn] ) {
                snList[item.sn]++;
            } else {
                snList[item.sn] = 1;
            }
        });

        info.result.forEach(function ( item ) {
            if ( !item.label ) {
                item.label = item.vendor + ' ' + item.model.replace(/\//, '');
                if ( snList[item.sn] > 1 ) {
                    item.label += ' #' + item.partitionNum;
                }
            }
        });

        // Sort by mount path
        info.result.sort();

        // Final list of all combined data
        return info.result;
    }
 
    return [];
};


/**
 * Get low-level information about mounted HDDs.
 *
 * @return {Object[]} info of connected HDD
 */
Fs.prototype.getHDDInfo = function () {
    'use strict';

    try {
        return JSON.parse(gSTB.RDir('get_hdd_info') || '[]');
    } catch ( error ) {
        return [];
    }
};


/**
 * Delete particular folder.
 *
 * @param {string} path path to the file system object
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.removeDir = function ( path, callback ) {
    'use strict';

    var command = 'RemoveDirFull "' + (path.charAt(path.length - 1) === '/' ? path.substr(0, path.length - 1) : path) + '"';

    tools.asyncCall(callback, null, gSTB.RDir(command) === 'Ok');
};


/**
 * Delete particular file.
 *
 * @param {string} path path to the file system object
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.removeFile = function ( path, callback ) {
    'use strict';

    tools.asyncCall(callback, null, gSTB.RDir('RemoveFile "' + path + '"') === 'Ok');
};


/**
 * Create directory by specified path.
 *
 * @param {string} path path for directory creation
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.createDir = function ( path, callback ) {
    'use strict';

    var self = this;

    gSTB.ExecAction('make_dir "' + path + '"');

    tools.asyncCall(function () {
        self.isFolderExist(path, function ( error, result ) {
            if ( error ) {
                callback(error);
            } else {
                callback(null, result);
            }
        });
    });
};


/**
 * Check if the given file has UTF8 encoding.
 *
 * @param {string} path file to test
 *
 * @return {boolean} result of operation
 */
Fs.prototype.isFileUTF8Encoded = function ( path ) {
    'use strict';

    return gSTB.IsFileUTF8Encoded(path);
};


/**
 * Test is file name point to existing file.
 *
 * @param {string} path absolute file path which will be tested
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.isFileExist = function ( path, callback ) {
    'use strict';

    tools.asyncCall(callback, null, gSTB.IsFileExist(path));
};


/**
 * Test is file name point to existing folder.
 *
 * @param {string} path absolute file path which will be tested
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.isFolderExist = function ( path, callback ) {
    'use strict';

    tools.asyncCall(callback, null, gSTB.IsFolderExist(path));
};


/**
 * Mount shared directory.
 *
 * @param {Object} config mount options
 * @param {string} config.address ip address
 * @param {string} config.login needed login
 * @param {string} config.pass needed pass
 * @param {function} callback method to invoke with a result of operation
 */
Fs.prototype.mount = function ( config, callback ) {
    'use strict';

    var login,
        pass,
        command,
        status;

    if ( config && config.address ) {
        config.address = config.address.charAt(config.address.length - 1) === '/' ?
            config.address.substr(0, config.address.length - 1) :
            config.address;
        login = config.login || 'guest';
        pass = config.pass ||  '';
        command = 'mount cifs "' + config.address +
            '" "' + (config.mountPath || this.mountPath) +
            '" username=' + login +
            ',password=' + pass +
            ',iocharset=utf8';
        status = gSTB.RDir(command).trim();
    }

    tools.asyncCall(callback, null, status === 'Ok');
};


/**
 * Umount folder (for example nfs or smb).
 *
 * @param {Object} config umount options
 * @param {boolean} config.force [force=false] flag to forcefully umount the resource
 * @param {boolean} config.mounted is directory already mounted
 * @param {boolean} config.path path for umount
 */
Fs.prototype.umount = function ( config ) {
    'use strict';

    if ( config.mounted || config.force ) {
        gSTB.ExecAction('umount_dir ' + config.path);
    }
};


module.exports = {
    onAppInit: function ( config, callback ) {
        // dome some asynchronous operations
        callback(null, new Fs(config));
    }
};
